import { render } from "./TopBar.vue?vue&type=template&id=5d359214&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=5d359214&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5d359214"

export default script